@if (show()) {
  <section class="consent-bar" role="region" [attr.aria-label]="'cookieConsent.label' | translate">
    <p class="consent-text">
      {{ 'cookieConsent.message' | translate }}
      <a routerLink="/cookies" class="consent-link">{{ 'cookieConsent.learnMore' | translate }}</a>
    </p>
    <div class="consent-actions">
      <button mat-stroked-button type="button" class="consent-decline" (click)="decline()">
        {{ 'cookieConsent.decline' | translate }}
      </button>
      <button mat-flat-button color="primary" type="button" class="consent-accept" (click)="accept()">
        {{ 'cookieConsent.accept' | translate }}
      </button>
    </div>
  </section>
}
